<template>
    <div v-if="!isDismissed" class="keyboard-shortcuts-compact">
        <span class="shortcuts-label">
            <span class="icon is-small">
                <i class="fas fa-keyboard"></i>
            </span>
            <span>{{ translate("admin_schedule_manage.keyboard_shortcuts.title") }}</span>
        </span>

        <div class="shortcuts-list">
            <span class="shortcut-group">
                <kbd class="kbd">
                    <i class="fas fa-arrow-left"></i>
                </kbd>
                <kbd class="kbd">
                    <i class="fas fa-arrow-right"></i>
                </kbd>
                <span class="shortcut-desc">{{ translate("admin_schedule_manage.keyboard_shortcuts.arrow_scroll") }}</span>
            </span>

            <span class="shortcut-divider"></span>

            <span class="shortcut-group">
                <kbd class="kbd">Ctrl</kbd>
                <span class="shortcut-desc">{{ translate("admin_schedule_manage.keyboard_shortcuts.ctrl_select") }}</span>
            </span>

            <span class="shortcut-divider"></span>

            <span class="shortcut-group">
                <kbd class="kbd">Shift</kbd>
                <span class="shortcut-desc">{{ translate("admin_schedule_manage.keyboard_shortcuts.shift_select") }}</span>
            </span>
        </div>

        <button class="dismiss-btn" @click="dismiss" :title="translate('common.close')">
            <i class="fas fa-times"></i>
        </button>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, onMounted } from "vue";
    import { translate } from "../../Common/translations";
    import { useScheduleMainStore } from "./useScheduleMainStore";

    const mainStore = useScheduleMainStore();
    const isDismissed = ref(false);

    const storageKey = computed(() => `schedule_keyboard_hints_dismissed_${mainStore.eventId}`);

    function dismiss() {
        isDismissed.value = true;
        localStorage.setItem(storageKey.value, "true");
    }

    onMounted(() => {
        const dismissed = localStorage.getItem(storageKey.value);
        isDismissed.value = dismissed === "true";
    });
</script>

<style scoped>
    .keyboard-shortcuts-compact {
        position: fixed;
        bottom: 1rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 50;
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.625rem 1rem;
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        font-size: 0.875rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .shortcuts-label {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: #64748b;
        font-weight: 500;
        white-space: nowrap;
    }

    .shortcuts-label .icon {
        font-size: 0.875rem;
        color: #94a3b8;
    }

    .shortcuts-list {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex-wrap: nowrap;
    }

    .shortcut-group {
        display: flex;
        align-items: center;
        gap: 0.375rem;
    }

    .kbd {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 1.5rem;
        height: 1.5rem;
        padding: 0 0.4rem;
        font-size: 0.75rem;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        font-weight: 600;
        color: #475569;
        background: white;
        border: 1px solid #cbd5e1;
        border-radius: 4px;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);
    }

    .kbd i {
        font-size: 0.7rem;
    }

    .shortcut-desc {
        color: #64748b;
        font-size: 0.8rem;
        white-space: nowrap;
    }

    .shortcut-divider {
        width: 1px;
        height: 1rem;
        background: #e2e8f0;
    }

    .dismiss-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.375rem;
        height: 1.375rem;
        padding: 0;
        margin-left: 0.375rem;
        color: #cbd5e1;
        background: transparent;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.1s ease;
        font-size: 0.75rem;
    }

    .dismiss-btn:hover {
        color: #64748b;
        background: #f1f5f9;
    }
</style>
